import { DateField, IntegerField, TextField } from "@dash/form";
import type { FC, KeyboardEvent } from "react";
import { useMemo } from "react";

import { normalizeSupportTicketProductionDate, supportTicketProductionDateToday } from "./supportTicketProductLabel";

type Props = {
  quantity: number;
  onQuantityChange: (value: number) => void;
  productionDate: Date | null;
  onProductionDateChange: (value: Date) => void;
  serialNumber: string;
  onSerialNumberChange: (value: string) => void;
  onEnterConfirm?: () => void;
  autoFocusQuantity?: boolean;
};

export const SupportTicketProductDialogFields: FC<Props> = ({
  quantity,
  onQuantityChange,
  productionDate,
  onProductionDateChange,
  serialNumber,
  onSerialNumberChange,
  onEnterConfirm,
  autoFocusQuantity = true,
}) => {
  const maxProductionDate = useMemo(() => supportTicketProductionDateToday(), []);

  const enterHandler = onEnterConfirm
    ? (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
          onEnterConfirm();
        }
      }
    : undefined;

  return (
    <>
      <IntegerField
        label="Ilość"
        value={quantity}
        onChange={onQuantityChange}
        autoFocus={autoFocusQuantity}
        inputElementProps={{ min: 1, onKeyDown: enterHandler }}
      />
      <DateField
        label="Data produkcji (opcjonalna)"
        value={productionDate}
        maxDate={maxProductionDate}
        onChange={(date) => {
          const normalized = normalizeSupportTicketProductionDate(date);
          if (normalized) onProductionDateChange(normalized);
        }}
      />
      <TextField
        label="Numer seryjny (opcjonalny)"
        value={serialNumber}
        onChange={onSerialNumberChange}
        inputElementProps={{ onKeyDown: enterHandler }}
      />
    </>
  );
};
